import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import Axios from 'axios';


function OrderList() {

    let { id } = useParams();

    const [orders, setOrders] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {

        Axios.get(`https://movie-project-01.herokuapp.com/orders/byUserId/${id}`, {
            headers: {
                accessToken: localStorage.getItem("accessToken")
            }
        }).then((response) => {
            setOrders(response.data);
        });
    }, []);

    return (
        <div className='continer4'>
            <h1>Orders</h1>
            <table class="table">
                <thead>
                    <tr>
                        <th scope='col' >Order Number</th>
                        <th scope="col">Order Date</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col">Detail</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => {
                        return (

                            <tr>
                                <td scope ='row'>{order.orderNumber}</td>
                                <td scope="row">{order.orderDate}</td>
                                <td scope="row">{order.quantity}</td>
                                <td scope="row">{order.totalPrice}</td>
                                <td scope="row">{order.status === 'Y' ? 'Active' : 'Cancelled'}</td>
                                <td scope="row"><Link className='btn' to={'/user/order/' + order.id}>view</Link></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>);
};



export default OrderList;



